import { render, staticRenderFns } from "./createRustDetectorTask.vue?vue&type=template&id=59651477&scoped=true&"
import script from "./createRustDetectorTask.vue?vue&type=script&lang=js&"
export * from "./createRustDetectorTask.vue?vue&type=script&lang=js&"
import style0 from "./createRustDetectorTask.vue?vue&type=style&index=0&id=59651477&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59651477",
  null
  
)

export default component.exports